module.exports = __webpack_public_path__ + "assets/img/title-719bf5f0.png";